import { z } from 'zod';
import { counterpartySchema } from "./stakes.js";
/** A day: more than anyone works off in one sitting, and a typo guard on a logged amount. */
export const MAX_LOGGED_MINUTES = 1440;
/**
 * The balance a session works off, as the browser names it: yourself, a registered user by id,
 * or an unregistered opponent by name.
 */
export const counterpartyRefSchema = z.discriminatedUnion('kind', [
    z.object({ kind: z.literal('self') }),
    z.object({ kind: z.literal('user'), userId: z.string().min(1) }),
    z.object({ kind: z.literal('opponent'), name: z.string().min(1) }),
]);
export const recordWorkRequestSchema = z.object({
    counterparty: counterpartyRefSchema,
    /** Null starts a timer; a number logs minutes already worked away from the app. */
    minutes: z.number().int().min(1).max(MAX_LOGGED_MINUTES).nullable(),
});
export const workSessionSchema = z.object({
    id: z.string().min(1),
    counterparty: counterpartySchema,
    startedAt: z.iso.datetime(),
    /** Null while the timer is still running. */
    finish: z
        .object({
        endedAt: z.iso.datetime(),
        /** Minutes worked; `credited` is what the balance could take (ADR-0018). */
        minutes: z.number().int().positive(),
        credited: z.number().int().nonnegative(),
    })
        .nullable(),
});
export const workListSchema = z.object({
    running: workSessionSchema.nullable(),
    /** The caller's most recent finished sessions, newest first. */
    recent: z.array(workSessionSchema),
});
//# sourceMappingURL=work.js.map